"use client";

import { Handshake } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function PartnershipCallout() {
  return <section id="partnershipcallout" data-nav="light" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.16, 1, 0.3, 1]
        }}>
            <Card className="border border-border/80 bg-card text-card-foreground shadow-sm rounded-2xl p-8 sm:p-12 text-center items-center">
              <CardContent className="flex flex-col items-center p-0 max-w-2xl">
                <div className="flex size-14 items-center justify-center rounded-full bg-primary/10 text-primary mb-6">
                  <Handshake className="size-7" aria-hidden="true" />
                </div>

                <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">
                  A partnership with Physiogenics
                </h2>

                <p className="mt-4 text-base sm:text-lg leading-relaxed text-muted-foreground">
                  PhysAnalytica&apos;s Batchwood clinic operates in partnership
                  with Physiogenics. Physiogenics runs and manages patients&apos;
                  healthcare and wellbeing at this location, while PhysAnalytica
                  provides specialist biomechanics expertise and support across
                  all services delivered here.
                </p>

                <div className="mt-8 flex justify-center">
                  <Button asChild size="lg" className="px-8 shadow-sm">
                    <Link to="https://physiogenics.uk3.cliniko.com/bookings?business_id=1933385715966552600" newTab>
                      Book an Appointment
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>;
}